// Copyright (c) 2016 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import actions from '../../../user/actions-list';
import {forceLanguageSupport} from '../services/user-settings-helpers';
import {getEntitlements} from './entitlements';
import {getSecurity} from './security';
import {getUseridAndUser} from './get-userid-and-user';
import {handleError} from '../../../shared/services/error-handlers';

const basePath = '/api';

export const getRacfId = async store => {

    try {

        const data = await getUseridAndUser();
        const supportedData = forceLanguageSupport(data);

        store.dispatch({
            data: supportedData,
            type: actions.UPDATE_USER_PREFERENCES_SUCCESS
        });

        store.dispatch({
            key: supportedData.settings.language.primaryLanguage.key,
            type: actions.UPDATE_USER_PREFERENCES_CURRENT_LANGUAGE_KEY
        });

        return supportedData;

    } catch (response) {

        return handleError(response);

    }

};
export const getUserSecurity = async store => {

    try {

        const user = await getRacfId(store);

        const security = await getSecurity(user.id);

        store.dispatch({
            security,
            type: actions.UPDATE_USER_SECURITY_SUCCESS
        });

        // load entitlements, but if not available we treat it as none

        let entitlements;

        try {

            entitlements = await getEntitlements(user.id);

        } catch (e) {

            entitlements = entitlements || [];

        }

        store.dispatch({
            entitlements,
            type: actions.UPDATE_USER_ENTITLEMENTS
        });

        return user;

    } catch (response) {

        return handleError(response);

    }

};

export const updateUser = async updatedUser => {

    const endPoint = `${basePath}/users/${updatedUser.id}`;
    const options = {
        body: JSON.stringify(updatedUser),
        method: 'PUT'
    };

    try {

        return await fetchService.fetch(endPoint, options);

    } catch (response) {

        return handleError(response);

    }

};



// WEBPACK FOOTER //
// ./src/user/shared/repositories/index.js